import menu4 from "../assets/images/menu-4.png";
import menu1 from "../assets/images/menu-1.png";
import menu2 from "../assets/images/menu-2.png";
import menuPolitics from "../assets/images/menu-2378961.png";
import menuCasino from "../assets/images/menu-99998.png";
import menuSportsBook from "../assets/images/menu-99991.png";
import menuHorseRacing from "../assets/images/menu-7.png";
import menuGreyhoundRacing from "../assets/images/menu-4339.png";
import menuBinary from "../assets/images/menu-99990.png";
import menuKabaddi from "../assets/images/menu-99994.png";
import menuBaseball from "../assets/images/menu-7511.png";
import menuBasketBall from "../assets/images/menu-7522.png";
import menuTableTennis from "../assets/images/menu-20.png";
import menuVolleyball from "../assets/images/menu-998917.png";
import menuIceHockey from "../assets/images/menu-7524.png";
import menu29 from "../assets/images/menu-29.png";
import menu5 from "../assets/images/menu-5.png";
import menu26420387 from "../assets/images/menu-26420387.png";
import menu3503 from "../assets/images/menu-3503.png";
import menuMultiMarket from "../assets/images/menu-market.png";

const l = (label, to = "/") => ({ label, to });

export const MENU_ITEMS = [
  {
    id: "multimarket",
    label: "Multi Market",
    icon: menuMultiMarket,
    collapsible: false,
    isLink: true,
    to: "/multi-market",
  },
  {
    id: "collapse0",
    label: "Cricket",
    icon: menu4,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      {
        id: "collapse00",
        label: "ICC Men's T20 World Cup",
        links: [
          l("ICC Men's T20 World Cup"),
          l("South Africa v New Zealand"),
          l("England v India"),
        ],
      },
      {
        id: "collapse01",
        label: "Others",
        links: [
          l("🎮ENGLAND T10 VS WEST INDIES T10"),
          l("🎮AUSTRALIA T10 VS INDIA T10"),
          l("🎮 ABU DHABI KNIGHT RIDERS SUPER OVER VS GULF GIANTS SUPER OVER"),
          l("🎮ENGLAND T10 VS SOUTH AFRICA T10"),
          l("🎮 HOBART HURRICANES SUPER OVER VS ADELAIDE STRIKERS SUPER OVER"),
          l("🎮WEST INDIES T10 VS ENGLAND T10"),
          l("🎮 LAHORE QALANDARS SUPER OVER VS KARACHI KINGS SUPER OVER"),
          l("🎮 WESTERN AUSTRALIA SUPER OVER VS VICTORIA SUPER OVER"),
          l("🎮AFGHANISTAN T10 VS WEST INDIES T10"),
          l(
            "🎮 PRETORIA CAPITALS SUPER OVER VS SUNRISERS EASTERN CAPE SUPER OVER",
          ),
          l("🎮NEW ZEALAND T10 VS SOUTH AFRICA T10"),
          l("🎮 TEXAS SUPER KINGS SUPER OVER VS WASHINGTON FREEDOM SUPER OVER"),
          l("Southern Rocks v Rhinos"),
          l("Tuskers v Mountaineers"),
          l("🎮 MI EMIRATES SUPER OVER VS SHARJAH WARRIORS SUPER OVER"),
          l("🎮 MELBOURNE RENEGADES SUPER OVER VS MELBOURNE STARS SUPER OVER"),
          l("🥊THE ROCK VS DRAGON LEE"),
          l("🎮NEW ZEALAND T10 VS PAKISTAN T10"),
          l("🎮PERTH SCORCHERS T10 VS SYDNEY SIXERS T10"),
          l("🎮 PESHAWAR ZALMI SUPER OVER VS MULTAN SULTANS SUPER OVER"),
          l("🥊RAQUEL RODRIGUEZ VS INDI HARTWELL"),
          l("🎮 PUNJAB KINGS SUPER OVER VS LUCKNOW SUPER GIANTS SUPER OVER"),
          l("🎮 PAARL ROYALS SUPER OVER VS JOBURG SUPER KINGS SUPER OVER"),
          l("🎮ZIMBABWE T10 VS NETHERLANDS T10"),
          l("🥊RIDGE HOLLAND VS THE HURRICANE"),
          l(
            "🎮 SAN FRANCISCO UNICORNS SUPER OVER VS LOS ANGELES KNIGHT RIDERS SUPER OVER",
          ),
          l("🎮SRI LANKA T10 VS BANGLADESH T10"),
          l("🎮 DUBAI CAPITALS SUPER OVER VS GULF GIANTS SUPER OVER"),
          l("🥊ANDRE CHASE VS ILJA DRAGUNOV"),
          l("🎮 BRISBANE HEAT SUPER OVER VS PERTH SCORCHERS SUPER OVER"),
          l("🎮ENGLAND T10 VS WEST INDIES T10"),
          l("🎮 QUETTA GLADIATORS SUPER OVER VS KARACHI KINGS SUPER OVER"),
          l("🎮INDIA T10 VS NEW ZEALAND T10"),
          l("🥊STING VS LA KNIGHT"),
          l("Abu Dhabi Smashers v Game Prime Aecor"),
        ],
      },
      {
        id: "collapse02",
        label: "India / T20 Muzaffarnagar Premier League",
        links: [
          l("Vasundhara Superkings v Silvertoan Panthers"),
          l("Cricgiri Champs v Rpl Riders"),
        ],
      },
      {
        id: "collapse03",
        label: "Simulated Reality League / Pakistan Super League SRL",
        links: [
          l("Multan Sultans SRL V Islamabad United SRL"),
          l("Quetta Gladiators SRL V Lahore Qalandars SRL"),
          l("Karachi Kings SRL V Peshawar Zalmi SRL"),
        ],
      },
      {
        id: "collapse04",
        label: "India / T20 DY Patil Trophy",
        links: [
          l("Dy Patil Blue v Canara Bank"),
          l("Reliance 1 v Bank of Baroda"),
          l("Dy Patil Red v Cgst"),
          l("Dtdc v Cag"),
        ],
      },
      {
        id: "collapse05",
        label: "Simulated Reality League / Super Smash SRL",
        links: [
          l("Auckland SRL V Wellington SRL"),
          l("Central Districts SRL V Auckland SRL"),
        ],
      },
      {
        id: "collapse06",
        label: "Uganda / Sabula T20 Cricket Challenge",
        links: [
          l("Kiyindi Blasters v Kitamba Sunrisers"),
          l("Nsonga Royals v Katosi Strikers"),
        ],
      },
      {
        id: "collapse07",
        label: "Simulated Reality League / Big Bash League SRL",
        links: [
          l("Sydney Sixers SRL V Brisbane Heat SRL"),
          l("Sydney Thunder SRL V Hobart Hurricanes SRL"),
          l("Melbourne Stars SRL V Melbourne Renegades SRL"),
        ],
      },
      {
        id: "collapse08",
        label: "Simulated Reality League / Premier League SRL",
        links: [
          l("Royal Challengers Bangalore SRL V Chennai Super Kings SRL"),
          l("Rajasthan Royals SRL V Delhi Capitals SRL"),
          l("Punjab Kings SRL V Gujarat Titans SRL"),
        ],
      },
      {
        id: "collapse09",
        label: "Simulated Reality League / Caribbean Premier League SRL",
        links: [
          l("Trinbago Knight Riders SRL V Antigua And Barbuda Falcons SRL"),
          l("Guyana Amazon Warriors SRL V St Lucia Kings SRL"),
        ],
      },
      {
        id: "collapse010",
        label: "Simulated Reality League / SA T20 League SRL",
        links: [
          l("Sunrisers Eastern Cape SRL V Mi Cape Town SRL"),
          l("Joburg Super Kings SRL V Pretoria Capitals SRL"),
        ],
      },
      {
        id: "collapse011",
        label: "CSA Provincial One-Day Challenge Div 1",
        links: [
          l("Western Province v Warriors"),
          l("North West Dragons v Lions"),
          l("Dolphins v Titans"),
        ],
      },
      {
        id: "collapse012",
        label: "Womens International Twenty20 Matches",
        links: [l("West Indies W v Sri Lanka W")],
      },
      {
        id: "collapse013",
        label: "Womens One Day Internationals",
        links: [l("New Zealand W v Zimbabwe W")],
      },
    ],
  },
  {
    id: "collapse1",
    label: "Football",
    icon: menu1,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      {
        id: "collapse10",
        label: "Others",
        links: [l("UEFA Champions League")],
      },
      {
        id: "collapse11",
        label: "South Korean K League 1",
        links: [l("Daejeon Citizen v FC Anyang")],
      },
      {
        id: "collapse12",
        label: "South Korean K League 2",
        links: [
          l("Chungnam Asan v Paju Citizen"),
          l("Busan IPark v Seongnam FC"),
        ],
      },
      {
        id: "collapse13",
        label: "Spanish Segunda Division",
        links: [
          l("Sporting Gijon v Leganes"),
          l("Sporting Gijon v Leganes"),
          l("Cordoba v Andorra CF"),
        ],
      },
      {
        id: "collapse14",
        label: "Republic of Korea / K-League 1",
        links: [l("Daejeon Citizen FC vs. FC Anyang")],
      },
      {
        id: "collapse15",
        label: "Republic of Korea / K-League 2",
        links: [l("Chungnam Asan FC vs. Paju Citizen FC")],
      },
      {
        id: "collapse16",
        label: "Australia / South Australia State League 1, Reserves",
        links: [l("Adelaide Blue Eagles Reserves vs. The Cove FC Reserves")],
      },
      {
        id: "collapse17",
        label: "AFC Ladies Asian Cup",
        links: [l("South Korea (W) v Iran (W)")],
      },
      {
        id: "collapse18",
        label: "Serie A SRL",
        links: [
          l("Udinese Calcio SRL vs. Fiorentina SRL"),
          l("Pisa SC Srl vs. Bologna FC SRL"),
        ],
      },
      {
        id: "collapse19",
        label: "LaLiga SRL",
        links: [l("Real Madrid SRL vs. Getafe CF SRL")],
      },
      {
        id: "collapse110",
        label: "Myanmar National League",
        links: [l("Rakhine Utd v Shan United")],
      },
      {
        id: "collapse111",
        label: "Victoria Premier League 1",
        links: [l("FC Bulleen Lions vs. Eltham Redbacks FC")],
      },
      {
        id: "collapse112",
        label: "Australia / South Australia State League 1",
        links: [l("Adelaide Blue Eagles vs. The Cove FC")],
      },
      {
        id: "collapse113",
        label:
          "International Youth / U19 European Championship, Women, Qualification",
        links: [l("Slovenia vs. San Marino"), l("Estonia vs. Cyprus")],
      },
      {
        id: "collapse114",
        label: "Turkiye Amateur / U19 Elit A",
        links: [l("Kocaelispor vs. Besiktas JK")],
      },
      {
        id: "collapse115",
        label: "Ukrainian Premier League",
        links: [l("SK Poltava v FK Kudrivka")],
      },
      {
        id: "collapse116",
        label: "Kenya / Premier League",
        links: [
          l("Mara Sugar FC vs. Sofapaka FC"),
          l("Kariobangi Sharks vs. Tusker Football Club"),
        ],
      },
      {
        id: "collapse117",
        label: "Kenyan Premier League",
        links: [
          l("Kakamega Homeboyz v Adm Police Service Bomet"),
          l("Bidco United v Ulinzi Stars"),
        ],
      },
      {
        id: "collapse118",
        label: "Portuguese U23",
        links: [l("Farense U23 v Vizela U23")],
      },
      {
        id: "collapse119",
        label: "Portugal / U23 Liga Revelacao",
        links: [l("SC Farense vs. FC Vizela")],
      },
      {
        id: "collapse120",
        label: "Friendlies Women's International",
        links: [l("Cyprus (W) v Faroe Islands (W)")],
      },
      {
        id: "collapse121",
        label: "Tanzania / Premier League",
        links: [
          l("Pamba Jiji SC vs. Azam FC"),
          l("Singida Black Stars SC vs. Coastal Union FC"),
        ],
      },
      {
        id: "collapse122",
        label: "English U21 Pro Development League",
        links: [
          l("Crewe U21 v Wigan Athletic U21"),
          l("Sheff Utd U21 v Sheff Wed U21"),
          l("Swansea U21 v Queens Park Rangers U21"),
          l("Peterborough United U21 v Hull City U21"),
          l("Watford U21 v Bournemouth U21"),
        ],
      },
      {
        id: "collapse123",
        label: "Tanzanian Premier League",
        links: [l("Singida Black Stars SC v Coastal Union")],
      },
      {
        id: "collapse124",
        label: "Uganda / Premier League",
        links: [
          l("Buhimba United Saints FC vs. Kampala Capital City Authority FC"),
        ],
      },
      {
        id: "collapse125",
        label: "Indonesian Super League",
        links: [
          l("PSM Makassar v Persita Tangerang"),
          l("Persebaya Surabaya v Persib Bandung"),
        ],
      },
      {
        id: "collapse126",
        label: "English Premier League 2 - Div 1",
        links: [l("Wolves U21 v Reading U21")],
      },
      {
        id: "collapse127",
        label: "Italy / Campionato Primavera 2",
        links: [l("Perugia vs. Ternana Calcio")],
      },
      {
        id: "collapse128",
        label: "Ivory Coast / Ligue 1",
        links: [l("Mouna FC vs. Stade D abidjan")],
      },
      {
        id: "collapse129",
        label: "Mali / Ligue 1",
        links: [l("Usfas Bamako vs. Derby Academie")],
      },
      {
        id: "collapse130",
        label: "Cameroonese Elite One",
        links: [l("Colombe du Dja et Lobo v Stade Renard")],
      },
      {
        id: "collapse131",
        label: "Serbian Super League",
        links: [l("FK IMT Novi Beograd v Radnik Surdulica")],
      },
      {
        id: "collapse132",
        label: "Bulgarian A League",
        links: [l("Ludogorets v Lokomotiv Plovdiv")],
      },
      {
        id: "collapse133",
        label: "Russia / 1. Liga",
        links: [l("Rodina Moscow vs. FC Shinnik Yaroslavl")],
      },
      {
        id: "collapse134",
        label: "International / Int. Friendly Games W",
        links: [l("Kenya vs. Benin")],
      },
      {
        id: "collapse135",
        label: "England / FA Cup",
        links: [l("Omonia v Apollon Limassol")],
      },
      {
        id: "collapse136",
        label: "Turkish 1 Lig",
        links: [l("Manisa FK v Corum Belediyespor")],
      },
      {
        id: "collapse137",
        label: "Turkiye / 1. Lig",
        links: [l("Manisa Futbol Kulubu vs. Corum FK")],
      },
      {
        id: "collapse138",
        label: "Romanian Liga I",
        links: [l("Unirea Slobozia v Rapid Bucharest")],
      },
      {
        id: "collapse139",
        label: "Italian Serie A",
        links: [l("Pisa v Bologna"), l("Udinese v Fiorentina")],
      },
      {
        id: "collapse140",
        label: "Brazil / U20 Campeonato Brasileiro",
        links: [
          l("EC Bahia BA vs. Fluminense FC RJ"),
          l("America FC MG vs. Botafogo FR RJ"),
          l("Avai FC SC vs. Red Bull Bragantino SP"),
        ],
      },
      {
        id: "collapse141",
        label: "Portuguese Segunda Liga",
        links: [l("Feirense v Felgueiras")],
      },
      {
        id: "collapse142",
        label: "Swedish Cup",
        links: [l("Orebro v Hammarby")],
      },
      {
        id: "collapse143",
        label: "Polish Ekstraklasa",
        links: [l("Zaglebie Lubin v Wisla Plock")],
      },
      {
        id: "collapse144",
        label: "Iraqi League",
        links: [
          l("Al Shorta SC vs. Al Kahrabaa SC"),
          l("Duhok FC vs. Newroz SC"),
        ],
      },
      {
        id: "collapse145",
        label: "Saudi 1st Division",
        links: [
          l("Al Draih v Al Batin"),
          l("Al-Arabi Al-Saudi v Jeddah Club"),
          l("Al Jabalain v Al-Zulfi SC"),
          l("Al-Adalh v Al Faisaly ( KSA )"),
        ],
      },
      {
        id: "collapse146",
        label: "Saudi Arabia / Division 1",
        links: [
          l("Al-Arabi SC (SA) vs. Jeddah Club"),
          l("Al-Jabalain vs. Al-Zulfi FC"),
        ],
      },
      {
        id: "collapse147",
        label: "England Amateur / U21 Premier League 2",
        links: [
          l("West Bromwich Albion vs. Derby County"),
          l("Crystal Palace FC vs. Sunderland"),
        ],
      },
      {
        id: "collapse148",
        label: "Hungary / NB II",
        links: [l("Bekescsaba 1912 Elore vs. Fehervar FC Szekesfehervar")],
      },
      {
        id: "collapse149",
        label: "Netherlands / Eerste Divisie",
        links: [l("FC Emmen vs. Jong FC Utrecht")],
      },
      {
        id: "collapse150",
        label: "Spain / LaLiga 2",
        links: [l("Cordoba CF vs. FC Andorra")],
      },
      {
        id: "collapse151",
        label: "Egyptian Premier",
        links: [
          l("Pharco FC v Kahraba Ismailia"),
          l("Al Ittihad (EGY) v Ghazl El Mahallah"),
        ],
      },
      {
        id: "collapse152",
        label: "Danish Superliga",
        links: [l("Udinese Calcio vs. ACF Fiorentina")],
      },
      {
        id: "collapse153",
        label: "France / Ligue 2",
        links: [l("Amiens SC vs. ESTAC Troyes")],
      },
      {
        id: "collapse154",
        label: "Ireland / Premier Division",
        links: [l("Saint Patrick´s Athletic FC vs. Galway United FC")],
      },
      {
        id: "collapse155",
        label: "Irish Premier Division",
        links: [l("St Patricks v Galway Utd")],
      },
      {
        id: "collapse156",
        label: "French Ligue 2",
        links: [l("Amiens v ESTAC Troyes")],
      },
      {
        id: "collapse157",
        label: "Bosnia &amp; Herzegovina / Premijer Liga",
        links: [l("FK Zeljeznicar Sarajevo vs. HSK Zrinjski Mostar")],
      },
      {
        id: "collapse158",
        label: "Spain / LaLiga",
        links: [l("Real Madrid vs. Getafe CF")],
      },
      {
        id: "collapse159",
        label: "Argentina / Copa Proyeccion Final, Reserves",
        links: [
          l("Independiente Reserve vs. CA Central Cordoba SE Reserve"),
          l("CA Union Santa Fe Reserve vs. CA Sarmiento de Junin"),
          l("Gimnasia de la Plata Reserve vs. Argentinos Juniors Reserve"),
        ],
      },
      {
        id: "collapse160",
        label: "English Championship",
        links: [l("Birmingham v Middlesbrough"), l("Ipswich v Hull")],
      },
      {
        id: "collapse161",
        label: "Spanish La Liga",
        links: [l("Real Madrid v Getafe"), l("Rayo Vallecano v Oviedo")],
      },
      {
        id: "collapse162",
        label: "Portuguese Primeira Liga",
        links: [l("Gil Vicente v Benfica")],
      },
      {
        id: "collapse163",
        label: "Honduras Liga Nacional",
        links: [l("Genesis Huracan v Lobos UPNFM")],
      },
      {
        id: "collapse164",
        label: "Argentinian Primera Division",
        links: [
          l("Estudiantes v Velez Sarsfield"),
          l("Deportivo Riestra v CA Platense"),
          l("Independiente Rivadavia v River Plate"),
          l("Banfield v Aldosivi"),
        ],
      },
      {
        id: "collapse165",
        label: "Argentinian Primera B Nacional",
        links: [l("CA Atlanta v Patronato")],
      },
      {
        id: "collapse166",
        label: "Colombian Primera B",
        links: [l("Tigres FC Zipaquira v Real Cartagena")],
      },
      {
        id: "collapse167",
        label: "Ecuadorian Serie A",
        links: [l("Manta FC v Independiente (Ecu)")],
      },
      {
        id: "collapse168",
        label: "Panamanian Premier League",
        links: [l("Alianza FC (Pan) v San Francisco FC")],
      },
      {
        id: "collapse169",
        label: "English Premier League",
        links: [
          l("Bournemouth v Brentford"),
          l("Leeds v Sunderland"),
          l("Everton v Burnley"),
          l("Wolves v Liverpool"),
          l("Aston Villa v Chelsea"),
          l("Fulham v West Ham"),
          l("Man City v Nottm Forest"),
          l("Brighton v Arsenal"),
          l("Newcastle v Man Utd"),
          l("Tottenham v Crystal Palace"),
        ],
      },
      {
        id: "collapse170",
        label: "Spanish Copa del Rey",
        links: [
          l("Barcelona v Atletico Madrid"),
          l("Real Sociedad v Athletic Bilbao"),
        ],
      },
      {
        id: "collapse171",
        label: "Italian Cup",
        links: [l("Como v Inter"), l("Lazio v Atalanta")],
      },
      {
        id: "collapse172",
        label: "Australian A-League Men",
        links: [
          l("Macarthur FC v Central Coast Mariners"),
          l("Adelaide United v Wellington Phoenix"),
        ],
      },
      {
        id: "collapse173",
        label: "German Bundesliga",
        links: [l("Hamburger SV v Leverkusen")],
      },
      {
        id: "collapse174",
        label: "French Ligue 1",
        links: [l("Paris St-G v Monaco")],
      },
      {
        id: "collapse175",
        label: "English Football League Cup",
        links: [l("Arsenal v Man City")],
      },
    ],
  },
  {
    id: "collapse2",
    label: "Tennis",
    icon: menu2,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      {
        id: "collapse20",
        label: "Virtual Tennis In-Play / Virtual Tennis In-Play",
        links: [
          l("Gofein vs. Queray"),
          l("Thimm vs. Bertich"),
          l("Raonnec vs. Tsogna"),
        ],
      },
      {
        id: "collapse21",
        label: "Fujairah Challenger 2026",
        links: [
          l("Sh Nakagawa v Kumasaka"),
          l("Ha Matsuoka v Mu Murtaza"),
          l("Ostapenkov v Ry Matsuda"),
          l("Yu Shimizu v Ro Karki"),
          l("Lopez Morillo v Takahashi"),
          l("Ke Chopra v Vla Orlov"),
          l("T Wu v Betov"),
          l("Erel v Ni McDonald"),
          l("Alkaya v Er Kirkin"),
          l("C Caniato v Ivashka"),
          l("Kusuhara v Gengel"),
          l("Balshaw v Ts Huang"),
        ],
      },
      {
        id: "collapse22",
        label: "WTA Antalya III 2026",
        links: [
          l("Te Kostovic v Pigossi"),
          l("Ele Pridankina v Mia Ristic"),
          l("B Kocak v Kat Zavatska"),
          l("Lisa Pigato v Ana Zolotareva"),
          l("M Sherif v Kawa"),
          l("T Zidansek v Erjavec"),
          l("Ley Romero Gormaz v Car Monnet"),
          l("Gasanova v P Udvardy"),
          l("Uchijima v Ad Kumru"),
          l("Ali Charaeva v Poli Kudermetova"),
          l("Ade Lachinova v Chwalinska"),
          l("Domi Salkova v El Avanesyan"),
          l("A Kalinina v Gorgodze"),
          l("G Maristany Zuleta De R v A Rus"),
          l("Ole Oliynykova v Nur Brancaccio"),
          l("Berfu Cengiz v L Bronzetti"),
        ],
      },
      {
        id: "collapse23",
        label: "WTA 125K / WTA 125K Antalya 2, Turkiye Women Singles",
        links: [
          l("Pridankina, Elena vs. Ristic, Mia"),
          l("Kostovic, Teodora vs. Pigossi, Laura"),
          l("Pigato, Lisa vs. Zolotareva, Anastasia"),
          l("Kocak, Berrak vs. Zavatska, Katarina"),
        ],
      },
      {
        id: "collapse24",
        label: "Hersonissos Challenger 2026",
        links: [
          l("Potenza v Carboni"),
          l("Bu Gadamauri v Loge"),
          l("Barranco Cosano v Pyo Nesterov"),
          l("A Barrera v Sv Gulin"),
          l("Dostanic v Lu Maxted"),
          l("Piraino v Piet Fellin"),
          l("Rybakov v Ja Berrettini"),
          l("Da Rincon v Durasovic"),
          l("Neumayer v Vasami"),
          l("Men Efstathiou v Moro Canas"),
        ],
      },
      {
        id: "collapse25",
        label: "Kigali Challenger 2026",
        links: [
          l("Sa Pieri v Iv Marrero Curbelo"),
          l("Napolitano v Neuchrist"),
          l("Roca Batalla v Mi Krom"),
          l("Nijboer v Ma Steiner"),
          l("Dalla Valle v G Voelzke"),
          l("Ee Vasa v Ionel"),
          l("Cecchinato v Az Ouakaa"),
          l("Martin v Jianu"),
          l("Bax v Pennaforti"),
          l("Forejtek v Lu Mikrut"),
          l("Trungelliti v Ga Johns"),
        ],
      },
      {
        id: "collapse26",
        label: "UTR Men / UTR PTT Krakow Men 02",
        links: [l("Bienkiewicz, Juliusz vs. Fajta, Peter")],
      },
      {
        id: "collapse27",
        label: "ATP Challenger Kigali 1, Rwanda Men Singles",
        links: [
          l("Roca Batalla, Oriol vs. De Krom, Michiel"),
          l("Nijboer, Ryan vs. Steiner, Maik"),
          l("Pieri, Samuele vs. Marrero Curbelo, Ivan"),
          l("Napolitano, Stefano vs. Neuchrist, Maximilian"),
          l("Cecchinato, Marco vs. Ouakaa, Aziz"),
          l("Martin, Andrej vs. Jianu, Filip Cristian"),
        ],
      },
      {
        id: "collapse28",
        label: "Challenger / ATP Challenger Hersonissos, Greece Men Singles",
        links: [
          l("Barranco Cosano, Javier vs. Nesterov, Pyotr"),
          l("Potenza, Luca vs. Carboni, Lorenzo"),
          l("Gadamauri, Buvaysar vs. Loge, Jack"),
          l("Dostanic, Stefan vs. Maxted, Lui"),
        ],
      },
      {
        id: "collapse29",
        label: "SRL Winter&nbsp;Invitational Larissa, GRE",
        links: [
          l("Djokovic, Novak (Srl) vs. Berrettini, Matteo (Srl)"),
          l("Bergs, Zizou (Srl) vs. Tsitsipas, Stefanos (Srl)"),
          l("Machac, Tomas (Srl) vs. Mpetshi Perricard, Giovanni (Srl)"),
          l("Paul, Tommy (Srl) vs. de Jong, Jesper (Srl)"),
          l("Mensik, Jakub (Srl) vs. Popyrin, Alexei (Srl)"),
          l("Mannarino, Adrian (Srl) vs. Kecmanovic, Miomir (Srl)"),
          l("Navone, Mariano (Srl) vs. Diallo, Gabriel (Srl)"),
          l("Bublik, Alexander (Srl) vs. Shevchenko, Alexander (Srl)"),
        ],
      },
      {
        id: "collapse210",
        label: "SRL Winter&nbsp;Invitational Patras, GRE",
        links: [
          l("Alcaraz, Carlos (Srl) vs. Dimitrov, Grigor (Srl)"),
          l("Rune, Holger (Srl) vs. Khachanov, Karen (Srl)"),
          l("Cobolli, Flavio (Srl) vs. Ugo Carabelli, Camilo (Srl)"),
          l("Draper, Jack (Srl) vs. Rinderknech, Arthur (Srl)"),
          l("Fritz, Taylor (Srl) vs. Darderi, Luciano (Srl)"),
          l("Munar, Jaume (Srl) vs. Tien, Learner (Srl)"),
          l("de Minaur, Alex (Srl) vs. Griekspoor, Tallon (Srl)"),
        ],
      },
      {
        id: "collapse211",
        label: "Challenger / ATP Challenger Fujairah, UAE Men Singles",
        links: [
          l("Hassan, Benjamin vs. Ivanov, Ivan"),
          l("Hewitt, Cruz vs. Shin, Sanhui"),
          l("Schoenhaus, Max vs. Zhou, Yi"),
          l("Stephens, Zach vs. Uchiyama, Yasutaka"),
          l("Gill, Felix vs. Basing, Max"),
          l("Harris, Lloyd vs. Faurel, Thomas"),
          l("Bar Biryukov, Petr vs. Fomin, Sergey"),
          l("Barton, Hynek vs. Boitan, Gabi Adrian"),
          l("Chung, Hyeon vs. Kubler, Jason"),
        ],
      },
      {
        id: "collapse212",
        label: "Thionville Challenger 2026",
        links: [
          l("Yo Watanuki v Fl Broska"),
          l("Molleker v Krumich"),
          l("Ch Broom v Blancaneaux"),
          l("Nishikori v Sels"),
          l("Oberleitner v Kee Smith"),
          l("Cassone v Lokoli"),
        ],
      },
      {
        id: "collapse213",
        label: "Brasilia Challenger 2026",
        links: [
          l("Joa Schiessl v Villalon Valdes"),
          l("Sanchez Jover v Dickerson"),
          l("Roncadelli v Scramin Do Lago"),
        ],
      },
      {
        id: "collapse214",
        label: "Challenger / ATP Challenger Thionville, France Men Singles",
        links: [l("Budkov Kjaer, Nicolai vs. Molcan, Alex")],
      },
      {
        id: "collapse215",
        label: "UTR Women / UTR PTT Saitama Women 02",
        links: [
          l("Ohashi, Yuna vs. Nakashima, Miyu"),
          l("Natsuka, Minori vs. Namigata, Junri"),
        ],
      },
      {
        id: "collapse216",
        label: "UTR Men / UTR PTT Saitama Men 02",
        links: [
          l("Kizaki, Ryuto vs. Nakagawa, Naoki"),
          l("Tanuma, Ryota vs. Belkovics, Achilles"),
        ],
      },
    ],
  },
  {
    id: "collapse3",
    label: "Politics",
    icon: menuPolitics,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [],
  },
  {
    id: "collapse4",
    label: "Casino",
    icon: menuCasino,
    collapsible: false,
    isLink: true,
    to: "/casino?category=ALL&providerCode=MAC88&subCategory=Aviator+X",
    highlight: true,
    subItems: [],
  },
  {
    id: "collapse5",
    label: "Sports book",
    icon: menuSportsBook,
    collapsible: false,
    isLink: true,
    to: "/",
    highlight: false,
    subItems: [],
  },
  {
    id: "collapse6",
    label: "Horse Racing",
    icon: menuHorseRacing,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      {
        id: "d0",
        label: "Penrith (AUS) 2nd Mar (11:44)",
        links: [l("Penrith (AUS) 2nd Mar (11:44)")],
      },
      {
        id: "d1",
        label: "Port Pirie (AUS) 2nd Mar (11:59)",
        links: [l("Port Pirie (AUS) 2nd Mar (11:59)")],
      },
      {
        id: "d2",
        label: "Pinjarra (AUS) 2nd Mar (12:12)",
        links: [l("Pinjarra (AUS) 2nd Mar (12:12)")],
      },
      {
        id: "d3",
        label: "Port Pirie (AUS) 2nd Mar (12:24)",
        links: [l("Port Pirie (AUS) 2nd Mar (12:24)")],
      },
      {
        id: "d4",
        label: "Terang (AUS) 2nd Mar (12:32)",
        links: [l("Terang (AUS) 2nd Mar (12:32)")],
      },
      {
        id: "d5",
        label: "Pinjarra (AUS) 2nd Mar (12:50)",
        links: [l("Pinjarra (AUS) 2nd Mar (12:50)")],
      },
      {
        id: "d6",
        label: "Terang (AUS) 2nd Mar (13:07)",
        links: [l("Terang (AUS) 2nd Mar (13:07)")],
      },
      {
        id: "d7",
        label: "Pinjarra (AUS) 2nd Mar (13:21)",
        links: [l("Pinjarra (AUS) 2nd Mar (13:21)")],
      },
      {
        id: "d8",
        label: "Terang (AUS) 2nd Mar (13:34)",
        links: [l("Terang (AUS) 2nd Mar (13:34)")],
      },
      {
        id: "d9",
        label: "Pinjarra (AUS) 2nd Mar (13:50)",
        links: [l("Pinjarra (AUS) 2nd Mar (13:50)")],
      },
      {
        id: "d10",
        label: "Terang (AUS) 2nd Mar (14:06)",
        links: [l("Terang (AUS) 2nd Mar (14:06)")],
      },
      {
        id: "d11",
        label: "Terang (AUS) 2nd Mar (14:41)",
        links: [l("Terang (AUS) 2nd Mar (14:41)")],
      },
      {
        id: "d12",
        label: "Terang (AUS) 2nd Mar (15:16)",
        links: [l("Terang (AUS) 2nd Mar (15:16)")],
      },
    ],
  },
  {
    id: "collapse7",
    label: "Greyhound Racing",
    icon: menuGreyhoundRacing,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      {
        id: "d0",
        label: "Shepparton (AUS) 2nd Mar (11:49)",
        links: [l("Shepparton (AUS) 2nd Mar (11:49)")],
      },
      {
        id: "d1",
        label: "Warrnambool (AUS) 2nd Mar (11:52)",
        links: [l("Warrnambool (AUS) 2nd Mar (11:52)")],
      },
      {
        id: "d2",
        label: "Shepparton (AUS) 2nd Mar (12:09)",
        links: [l("Shepparton (AUS) 2nd Mar (12:09)")],
      },
      {
        id: "d3",
        label: "Warrnambool (AUS) 2nd Mar (12:17)",
        links: [l("Warrnambool (AUS) 2nd Mar (12:17)")],
      },
      {
        id: "d4",
        label: "Shepparton (AUS) 2nd Mar (12:29)",
        links: [l("Shepparton (AUS) 2nd Mar (12:29)")],
      },
      {
        id: "d5",
        label: "Warrnambool (AUS) 2nd Mar (12:37)",
        links: [l("Warrnambool (AUS) 2nd Mar (12:37)")],
      },
      {
        id: "d6",
        label: "Ballarat (AUS) 2nd Mar (12:44)",
        links: [l("Ballarat (AUS) 2nd Mar (12:44)")],
      },
      {
        id: "d7",
        label: "Shepparton (AUS) 2nd Mar (12:47)",
        links: [l("Shepparton (AUS) 2nd Mar (12:47)")],
      },
      {
        id: "d8",
        label: "Murray Bridge (AUS) 2nd Mar (12:59)",
        links: [l("Murray Bridge (AUS) 2nd Mar (12:59)")],
      },
      {
        id: "d9",
        label: "Nowra (AUS) 2nd Mar (13:02)",
        links: [l("Nowra (AUS) 2nd Mar (13:02)")],
      },
      {
        id: "d10",
        label: "Ballarat (AUS) 2nd Mar (13:05)",
        links: [l("Ballarat (AUS) 2nd Mar (13:05)")],
      },
      {
        id: "d11",
        label: "Shepparton (AUS) 2nd Mar (13:09)",
        links: [l("Shepparton (AUS) 2nd Mar (13:09)")],
      },
      {
        id: "d12",
        label: "Maitland (AUS) 2nd Mar (13:12)",
        links: [l("Maitland (AUS) 2nd Mar (13:12)")],
      },
      {
        id: "d13",
        label: "Murray Bridge (AUS) 2nd Mar (13:19)",
        links: [l("Murray Bridge (AUS) 2nd Mar (13:19)")],
      },
      {
        id: "d14",
        label: "Nowra (AUS) 2nd Mar (13:26)",
        links: [l("Nowra (AUS) 2nd Mar (13:26)")],
      },
      {
        id: "d15",
        label: "Ballarat (AUS) 2nd Mar (13:29)",
        links: [l("Ballarat (AUS) 2nd Mar (13:29)")],
      },
      {
        id: "d16",
        label: "Maitland (AUS) 2nd Mar (13:32)",
        links: [l("Maitland (AUS) 2nd Mar (13:32)")],
      },
      {
        id: "d17",
        label: "Q Straight (AUS) 2nd Mar (13:39)",
        links: [l("Q Straight (AUS) 2nd Mar (13:39)")],
      },
      {
        id: "d18",
        label: "Murray Bridge (AUS) 2nd Mar (13:42)",
        links: [l("Murray Bridge (AUS) 2nd Mar (13:42)")],
      },
      {
        id: "d19",
        label: "Ballarat (AUS) 2nd Mar (13:45)",
        links: [l("Ballarat (AUS) 2nd Mar (13:45)")],
      },
      {
        id: "d20",
        label: "Nowra (AUS) 2nd Mar (13:52)",
        links: [l("Nowra (AUS) 2nd Mar (13:52)")],
      },
      {
        id: "d21",
        label: "Mandurah (AUS) 2nd Mar (13:55)",
        links: [l("Mandurah (AUS) 2nd Mar (13:55)")],
      },
      {
        id: "d22",
        label: "Maitland (AUS) 2nd Mar (13:58)",
        links: [l("Maitland (AUS) 2nd Mar (13:58)")],
      },
      {
        id: "d23",
        label: "Q Straight (AUS) 2nd Mar (14:01)",
        links: [l("Q Straight (AUS) 2nd Mar (14:01)")],
      },
      {
        id: "d24",
        label: "Murray Bridge (AUS) 2nd Mar (14:04)",
        links: [l("Murray Bridge (AUS) 2nd Mar (14:04)")],
      },
      {
        id: "d25",
        label: "Ballarat (AUS) 2nd Mar (14:11)",
        links: [l("Ballarat (AUS) 2nd Mar (14:11)")],
      },
      {
        id: "d26",
        label: "Nowra (AUS) 2nd Mar (14:14)",
        links: [l("Nowra (AUS) 2nd Mar (14:14)")],
      },
      {
        id: "d27",
        label: "Mandurah (AUS) 2nd Mar (14:17)",
        links: [l("Mandurah (AUS) 2nd Mar (14:17)")],
      },
      {
        id: "d28",
        label: "Maitland (AUS) 2nd Mar (14:20)",
        links: [l("Maitland (AUS) 2nd Mar (14:20)")],
      },
      {
        id: "d29",
        label: "Q Straight (AUS) 2nd Mar (14:27)",
        links: [l("Q Straight (AUS) 2nd Mar (14:27)")],
      },
      {
        id: "d30",
        label: "Ballarat (AUS) 2nd Mar (14:30)",
        links: [l("Ballarat (AUS) 2nd Mar (14:30)")],
      },
      {
        id: "d31",
        label: "Murray Bridge (AUS) 2nd Mar (14:33)",
        links: [l("Murray Bridge (AUS) 2nd Mar (14:33)")],
      },
      {
        id: "d32",
        label: "Nowra (AUS) 2nd Mar (14:36)",
        links: [l("Nowra (AUS) 2nd Mar (14:36)")],
      },
      {
        id: "d33",
        label: "Mandurah (AUS) 2nd Mar (14:39)",
        links: [l("Mandurah (AUS) 2nd Mar (14:39)")],
      },
      {
        id: "d34",
        label: "Maitland (AUS) 2nd Mar (14:46)",
        links: [l("Maitland (AUS) 2nd Mar (14:46)")],
      },
      {
        id: "d35",
        label: "Q Straight (AUS) 2nd Mar (14:49)",
        links: [l("Q Straight (AUS) 2nd Mar (14:49)")],
      },
      {
        id: "d36",
        label: "Ballarat (AUS) 2nd Mar (14:52)",
        links: [l("Ballarat (AUS) 2nd Mar (14:52)")],
      },
      {
        id: "d37",
        label: "Murray Bridge (AUS) 2nd Mar (14:55)",
        links: [l("Murray Bridge (AUS) 2nd Mar (14:55)")],
      },
      {
        id: "d38",
        label: "Nowra (AUS) 2nd Mar (14:58)",
        links: [l("Nowra (AUS) 2nd Mar (14:58)")],
      },
      {
        id: "d39",
        label: "Mandurah (AUS) 2nd Mar (15:05)",
        links: [l("Mandurah (AUS) 2nd Mar (15:05)")],
      },
      {
        id: "d40",
        label: "Maitland (AUS) 2nd Mar (15:08)",
        links: [l("Maitland (AUS) 2nd Mar (15:08)")],
      },
      {
        id: "d41",
        label: "Q Straight (AUS) 2nd Mar (15:11)",
        links: [l("Q Straight (AUS) 2nd Mar (15:11)")],
      },
      {
        id: "d42",
        label: "Ballarat (AUS) 2nd Mar (15:14)",
        links: [l("Ballarat (AUS) 2nd Mar (15:14)")],
      },
      {
        id: "d43",
        label: "Murray Bridge (AUS) 2nd Mar (15:21)",
        links: [l("Murray Bridge (AUS) 2nd Mar (15:21)")],
      },
      {
        id: "d44",
        label: "Nowra (AUS) 2nd Mar (15:24)",
        links: [l("Nowra (AUS) 2nd Mar (15:24)")],
      },
      {
        id: "d45",
        label: "Mandurah (AUS) 2nd Mar (15:27)",
        links: [l("Mandurah (AUS) 2nd Mar (15:27)")],
      },
      {
        id: "d46",
        label: "Maitland (AUS) 2nd Mar (15:30)",
        links: [l("Maitland (AUS) 2nd Mar (15:30)")],
      },
      {
        id: "d47",
        label: "Q Straight (AUS) 2nd Mar (15:33)",
        links: [l("Q Straight (AUS) 2nd Mar (15:33)")],
      },
      {
        id: "d48",
        label: "Ballarat (AUS) 2nd Mar (15:40)",
        links: [l("Ballarat (AUS) 2nd Mar (15:40)")],
      },
      {
        id: "d49",
        label: "Murray Bridge (AUS) 2nd Mar (15:44)",
        links: [l("Murray Bridge (AUS) 2nd Mar (15:44)")],
      },
      {
        id: "d50",
        label: "Nowra (AUS) 2nd Mar (15:48)",
        links: [l("Nowra (AUS) 2nd Mar (15:48)")],
      },
    ],
  },
  {
    id: "collapse8",
    label: "Binary",
    icon: menuBinary,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      { id: "collapse80", label: "Others", links: [l("Binary / 2026/03/02")] },
    ],
  },
  {
    id: "collapse9",
    label: "Kabaddi",
    icon: menuKabaddi,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [],
  },
  {
    id: "collapse10",
    label: "Basketball",
    icon: menuBasketBall,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      {
        id: "collapse100",
        label: "Turkiye / Super Lig, Women",
        links: [
          l("Fenerbahce SK vs. Kayseri Basketbol"),
          l("Emlak Konut SK vs. Botas SK"),
        ],
      },
      {
        id: "collapse101",
        label: "China / NBL",
        links: [l("Hangzhou Jingwei vs. Hong Kong Bulls")],
      },
      {
        id: "collapse102",
        label: "TBL",
        links: [l("OGM Ormanspor vs. Fenerbahce Koleji")],
      },
      {
        id: "collapse103",
        label: "Turkiye / 1. Lig, Women",
        links: [
          l("Secil Kaucuk Mersin Basketball vs. Kirklareli Fen Bilimleri"),
          l("Darica Basketbol Feneri vs. Mersin Genclerbirligi"),
        ],
      },
      {
        id: "collapse104",
        label: "Romania / LNB, Women",
        links: [l("CSU Cluj-Napoca vs. CSM Targoviste")],
      },
      {
        id: "collapse105",
        label: "Greece / Elite League",
        links: [l("Ne Megaridos vs. Proteas Voulas")],
      },
      {
        id: "collapse106",
        label: "International / World Cup Qualification, Europe",
        links: [
          l("Lithuania vs. Iceland"),
          l("Georgia vs. Denmark"),
          l("Romania vs. Portugal"),
          l("Switzerland vs. Bosnia &amp; Herzegovina"),
          l("Italy vs. Great Britain"),
        ],
      },
      {
        id: "collapse107",
        label: "Israel / WBL, Women",
        links: [l("Hapoel Rishon Letzion vs. Maccabi Ashdod")],
      },
      {
        id: "collapse108",
        label: "International / EuroBasket, Qualification",
        links: [l("Albania vs. Slovakia")],
      },
    ],
  },
  {
    id: "collapse11",
    label: "Baseball",
    icon: menuBaseball,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      {
        id: "collapse110",
        label: "Virtual Baseball / Virtual Baseball In-Play",
        links: [l("Colorado Rockies vs. Washington Nationals")],
      },
      {
        id: "collapse111",
        label: "USA / MLB Spring Training",
        links: [
          l("St. Louis Cardinals vs. Miami Marlins"),
          l("Pittsburgh Pirates vs. Tampa Bay Rays"),
          l("Detroit Tigers vs. Atlanta Braves"),
          l("Houston Astros vs. Washington Nationals"),
          l("Toronto Blue Jays vs. Boston Red Sox"),
          l("Chicago White Sox vs. San Francisco Giants"),
          l("Cincinnati Reds vs. Chicago Cubs"),
          l("Texas Rangers vs. Cleveland Guardians"),
          l("Los Angeles Angels vs. Kansas City Royals"),
          l("Colorado Rockies vs. Los Angeles Dodgers"),
          l("San Diego Padres vs. Athletics"),
        ],
      },
      {
        id: "collapse112",
        label: "USA / NCAA, Regular Season",
        links: [
          l("Lipscomb Bisons vs. Toledo Rockets"),
          l("UT Arlington Mavericks vs. Air Force Falcons"),
          l("Washington Huskies vs. San Diego State Aztecs"),
          l("Loyola Marymount Lions vs. Utah Utes"),
          l("Stanford Cardinal vs. Nevada Wolf Pack"),
          l("Seattle Redhawks vs. Holy Cross Crusaders"),
          l("LSU Tigers vs. Northeastern Huskies"),
        ],
      },
    ],
  },
  {
    id: "collapse12",
    label: "Table Tennis",
    icon: menuTableTennis,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      {
        id: "collapse120",
        label: "International / TT Elite Series",
        links: [
          l("Kotyl, Krzysztof vs. Iwasyszyn, Wojciech"),
          l("Sklensky, Miroslav vs. Jarocki, Lukasz"),
          l("Nowak, Jakub vs. Gumulinski, Piotr"),
          l("Braun, Josef vs. Benes, Michal"),
          l("Stechly, Witold vs. Fomin, Andriej"),
          l("Linek, Adam vs. Poliniewicz, Grzegorz"),
          l("Czerwinski, Bartosz vs. Wisniewski, Karol"),
          l("Wisniewski, Bartlomiej vs. Iwasyszyn, Wojciech"),
          l("Jadczyk, Marcin vs. Klos, Patrik"),
          l("Wichowski, Grzegorz vs. Tobiasz, Wojciech"),
          l("Miastowski, Maksymilian vs. Sklensky, Miroslav"),
          l("Witkowski, Antoni vs. Martinko, Tomas"),
          l("Wloczko, Krzysztof vs. Jarocki, Lukasz"),
          l("Benes, Michal vs. Klos, Patrik"),
          l("Czerwinski, Bartosz vs. Sklensky, Miroslav"),
          l("Braun, Josef vs. Witkowski, Antoni"),
          l("Miastowski, Maksymilian vs. Wloczko, Krzysztof"),
          l("Jadczyk, Marcin vs. Martinko, Tomas"),
          l("Jarocki, Lukasz vs. Wisniewski, Karol"),
          l("Benes, Michal vs. Witkowski, Antoni"),
          l("Czerwinski, Bartosz vs. Wloczko, Krzysztof"),
          l("Braun, Josef vs. Jadczyk, Marcin"),
        ],
      },
      {
        id: "collapse121",
        label: "Czech Liga Pro",
        links: [
          l("Revay, Radomir vs. Zika, Tadeas"),
          l("Ulrych, Martin vs. Potensky, Jan"),
          l("Stefek, Martin vs. Cetner, Milan"),
          l("Tuma, Daniel vs. Cermak, Vladimir"),
          l("Tazler, Jakub vs. Sobisek, Martin"),
          l("Nohejl, Tomas vs. Chalupnicek, Milan"),
          l("Paril, Ondrej vs. Szotkowski, Jan"),
          l("Kaspar, Michal vs. Kowolowski, Miroslav"),
          l("Grohsgott, Jiri vs. Hejduk, Alexander"),
          l("Cermak, Vladimir vs. Tazler, Jakub"),
          l("Zika, Tadeas vs. Paril, Ondrej"),
          l("Cetner, Milan vs. Nohejl, Tomas"),
          l("Potensky, Jan vs. Grohsgott, Jiri"),
          l("Kowolowski, Miroslav vs. Varecha, Pavel"),
          l("Chalupnicek, Milan vs. Stefek, Martin"),
          l("Szotkowski, Jan vs. Revay, Radomir"),
          l("Hejduk, Alexander vs. Ulrych, Martin"),
          l("Sobisek, Martin vs. Tuma, Daniel"),
          l("Stefek, Martin vs. Nohejl, Tomas"),
          l("Revay, Radomir vs. Paril, Ondrej"),
          l("Tuma, Daniel vs. Tazler, Jakub"),
        ],
      },
      {
        id: "collapse122",
        label: "International / TT Cup",
        links: [
          l("Cerveny Jr, Tomas vs. Rein, Tomas"),
          l("Holik, Simon vs. Dvorak, Martin"),
          l("Cerveny Jr, Tomas vs. Dvorak, Martin"),
          l("Rein, Tomas vs. Holik, Simon"),
        ],
      },
    ],
  },
  {
    id: "collapse13",
    label: "Volleyball",
    icon: menuVolleyball,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      {
        id: "collapse130",
        label: "Republic of Korea / V League",
        links: [l("Suwon Vixtorm vs. Incheon Jumbos")],
      },
      {
        id: "collapse131",
        label: "Republic of Korea / V League, Women",
        links: [l("Seoul KIXX vs. Daejeon Pro VC")],
      },
      {
        id: "collapse132",
        label: "Turkiye / Cup, Women",
        links: [l("Eczacibasi Istanbul vs. Goztepe")],
      },
      {
        id: "collapse133",
        label: "Poland / Liga Siatkowki",
        links: [l("Chks Chelm vs. MKS Slepsk Suwalki")],
      },
      {
        id: "collapse134",
        label: "Poland / Liga Siatkowki, Women",
        links: [
          l("Nowy Dwor Mazowiecki vs. KS Rzeszow"),
          l("Radomka Radom vs. Bks Bielsko-Biala"),
        ],
      },
      {
        id: "collapse135",
        label: "Superliga",
        links: [l("Sao Jose Dos Campos vs. Volei Guarulhos")],
      },
    ],
  },
  {
    id: "collapse14",
    label: "Ice Hockey",
    icon: menuIceHockey,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      {
        id: "collapse140",
        label: "Russia / VHL",
        links: [l("Chelmet Chelyabinsk vs. Dizel Penza")],
      },
      {
        id: "collapse141",
        label: "Russia / MHL",
        links: [
          l("MHC Dinamo Saint Petersburg vs. JHC Spartak Moskow"),
          l("Sputnik Almetievsk vs. Tolpar UFA"),
          l("Reaktor Nizhnekamsk vs. Stalnye Lisy"),
          l("SKA-1946 Saint Petersburg vs. Krasnaya Armiya"),
        ],
      },
      {
        id: "collapse142",
        label: "Belarus / Extraliga",
        links: [l("HK Vitebsk vs. HC Dinamo Molodechno")],
      },
      {
        id: "collapse143",
        label: "Russia / KHL",
        links: [
          l("Severstal Cherepovets vs. Lokomotiv Yaroslavl"),
          l("Spartak Moscow vs. HK Avangard Omsk"),
        ],
      },
      {
        id: "collapse144",
        label: "Finland / Mestis",
        links: [l("Imatran Kettera vs. Rovaniemen Kiekko")],
      },
      {
        id: "collapse145",
        label: "Denmark / Superisligaen",
        links: [l("SoenderjyskE Ishockey vs. Roedovre Mighty Bulls")],
      },
      {
        id: "collapse146",
        label: "USA / NHL",
        links: [
          l("Nashville Predators vs. Detroit Red Wings"),
          l("New York Rangers vs. Columbus Blue Jackets"),
          l("Toronto Maple Leafs vs. Philadelphia Flyers"),
          l("Seattle Kraken vs. Carolina Hurricanes"),
          l("Vancouver Canucks vs. Dallas Stars"),
          l("Los Angeles Kings vs. Colorado Avalanche"),
        ],
      },
    ],
  },
  {
    id: "collapse15",
    label: "Rugby",
    icon: menu5,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [],
  },
  {
    id: "collapse16",
    label: "Mixed Martial Arts",
    icon: menu26420387,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [],
  },
  {
    id: "collapse17",
    label: "Darts",
    icon: menu3503,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      {
        id: "collapse170",
        label: "International / Modus Super Series",
        links: [
          l("Dekker, Patrick vs. Mould, Adam"),
          l("Slevin, Dylan vs. Mitchell, Scott"),
          l("Mould, Adam vs. Duff, Neil"),
          l("McCaughern, Colin vs. Dekker, Patrick"),
          l("Slevin, Dylan vs. Mould, Adam"),
          l("Mitchell, Scott vs. Dekker, Patrick"),
          l("Duff, Neil vs. McCaughern, Colin"),
          l("Mould, Adam vs. Mitchell, Scott"),
          l("McCaughern, Colin vs. Slevin, Dylan"),
          l("Dekker, Patrick vs. Duff, Neil"),
          l("McCaughern, Colin vs. Mould, Adam"),
        ],
      },
    ],
  },
  {
    id: "collapse18",
    label: "Futsal",
    icon: menu29,
    collapsible: true,
    isLink: false,
    highlight: false,
    subItems: [
      {
        id: "collapse180",
        label: "Russia / Superliga",
        links: [l("MFk Kprf vs. Sibiryak")],
      },
    ],
  },
];
